import type { EmailCalendarLinks } from '@/types/email.types';

export interface CalendarLinksWidgetProps {
  links?: EmailCalendarLinks;
  color?: string;
  fontFamily?: string;
  padding?: string;
}

export default function CalendarLinksWidget({
  links,
  color = 'var(--secondary-accent)',
  fontFamily = 'var(--body-font)',
  padding = '24px 0',
}: CalendarLinksWidgetProps) {
  if (!links) return null;

  const linkStyle = {
    color,
    fontSize: '12px',
    fontFamily,
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.24px',
  };
  const dotStyle = {
    padding: '0 4px',
    color,
    fontSize: '11px',
    fontFamily: "'TASA Orbiter', sans-serif",
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0.22px',
  };

  return (
    <table role="presentation" width="100%" cellPadding={0} cellSpacing={0} border={0}>
      <tbody>
        <tr>
          <td align="center" style={{ padding }}>
            <table cellPadding={0} cellSpacing={0} border={0} role="presentation">
              <tbody>
                <tr>
                  <td>
                    <a style={linkStyle} href={links.iCal}>
                      iCal
                    </a>
                  </td>
                  <td style={dotStyle}>•</td>
                  <td>
                    <a style={linkStyle} href={links.outlook}>
                      Outlook
                    </a>
                  </td>
                  <td style={dotStyle}>•</td>
                  <td>
                    <a style={linkStyle} href={links.google}>
                      Google
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
